export default __webpack_public_path__ + "static/media/target-audience.092ced25.jpg";